// Shiprocket Button Fix - Force preserve and reinitialize
// Add this AFTER Shiprocket script loads in theme.liquid

(function() {
  'use strict';
  
  let shiprocketButtonBackup = null;
  let checkInterval = null;
  
  // Function to backup the Shiprocket button
  function backupShiprocketButton() {
    const container = document.querySelector('.shiprocket-headless[data-type="product"]');
    if (container) {
      const button = container.querySelector('.sr-headless-checkout');
      if (button && !shiprocketButtonBackup) {
        shiprocketButtonBackup = button.cloneNode(true);
        console.log('✓ Shiprocket button backed up');
      }
    }
  }
  
  // Function to restore the button if it's missing
  function restoreShiprocketButton() {
    const container = document.querySelector('.shiprocket-headless[data-type="product"]');
    if (container && shiprocketButtonBackup) {
      const existingButton = container.querySelector('.sr-headless-checkout');
      
      if (!existingButton) {
        console.log('⚠ Shiprocket button missing, restoring...');
        const restoredButton = shiprocketButtonBackup.cloneNode(true);
        container.appendChild(restoredButton);
        
        // Re-attach event listeners if needed
        reattachButtonEvents(restoredButton);
      }
    }
  }
  
  // Re-attach click events to the restored button
  function reattachButtonEvents(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Try to trigger Shiprocket's original function
      if (typeof window.openShiprocketCheckout === 'function') {
        window.openShiprocketCheckout();
      } else if (typeof window.shiprocketCheckout === 'function') {
        window.shiprocketCheckout();
      } else {
        console.warn('Shiprocket checkout function not found');
      }
    });
  }
  
  // Continuously monitor and restore if needed
  function startMonitoring() {
    checkInterval = setInterval(function() {
      restoreShiprocketButton();
    }, 500);
  }
  
  // Initialize when DOM is ready
  function init() {
    // Wait for Shiprocket to load
    setTimeout(function() {
      backupShiprocketButton();
      startMonitoring();
      
      // Listen to variant changes
      document.addEventListener('change', function(e) {
        if (e.target.matches('input[type="radio"][data-option-position]')) {
          console.log('Variant changed');
          setTimeout(function() {
            backupShiprocketButton();
            restoreShiprocketButton();
          }, 100);
        }
      });
      
    }, 2000); // Wait 2 seconds for Shiprocket to initialize
  }
  
  // Start when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();